import React, { useRef } from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import "./linksPopupMenu.scss";
import useClickOutside from "src/app/hooks/useClickOustide";
import { Link } from "navigation";
import { useSearchParams } from "next/navigation";
import { handleLocaleFormat } from "src/app/utils/helpers";

const LinksPopupMenu = ({
  subLinks,
  setShowDropdown,
  languagesLinks,
  pathname,
  currentLocale,
  t,
  maxWidth = null,
  parentRef = null
}) => {
  const customFlags = {
    'en' : 'gb',
    'pt-BR' : 'br',
    'zh-CN' : 'cn',
  }
  
  const dropdownRef = useRef(null);
  useClickOutside(dropdownRef , parentRef, () => setShowDropdown(false));
  const searchParams = useSearchParams();
  
  const query = Object.fromEntries(searchParams.entries());
  const variants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.3,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };
  return (
    <motion.div
      ref={dropdownRef}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      className={`links-popup-menu ${
        maxWidth ? `max-w-max` : "max-w-max min-w-[220px]"
      }`}
    >
      <div
        className="content-container min-w-full max-w-max"
      >
        {subLinks?.map((link) => (
          <Link
            className="sublink"
            href={link.path}
            key={link.name}
          >
            {link.name}
          </Link>
        ))}
        {languagesLinks?.map((locale) => 
        
        {
          const formatedLocale = handleLocaleFormat(locale)
          return (
          <Link
            key={locale}
            href={{pathname: pathname, query: query}}
            locale={locale}
            className={`lang-link ${
              currentLocale === locale ? "active" : ""
            }`}
          >
            <Image
              className="mr-1"
              src={`https://hatscripts.github.io/circle-flags/flags/${
                customFlags[locale] ??  locale
              }.svg`}
              alt="ROLZO in different languages"
              width="17"
              height="17"
            />
            <p>
              {t("locale", { locale: formatedLocale })}
              </p>
          </Link>
        )})}
      </div>
    </motion.div>
  );
};

export default LinksPopupMenu;
